<template>
  <div class="inbound-exception-page">
    <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="异常商品" name="product"></el-tab-pane>
      <el-tab-pane label="异常包裹" name="parcel"></el-tab-pane>
    </el-tabs>
    <div class="filter-row">
      <InterForm ref="InterForm" :exceptionType="exceptionType" :replyUserOptions="replyUserOptions" @querySubmit="queryHandler" />
      <InterBtnBox @create="openCreate" @export="exportExcel" />
    </div>
    <InterList
      ref="interlist"
      :dataSource="dataSource"
      :total="query.total"
      :exceptionType="exceptionType"
      @pageChange="pageChangeCall"
      @edit="openEdit"
      @remove="removeRecord"
      @reply="openReply"
      @log="openLog"
    />
    <ExceptionFormDrawer ref="formDrawer" :replyUserOptions="replyUserOptions" @confirm="getDataSource" />
    <ReplyDrawer ref="replyDrawer" @confirm="getDataSource" />
    <LogDrawer ref="logDrawer" />
  </div>
</template>

<script>
import InterForm from "./components/InterForm";
import InterBtnBox from "./components/InterBtnBox";
import InterList from "./components/InterList";
import ExceptionFormDrawer from "./components/ExceptionFormDrawer";
import ReplyDrawer from "./components/ReplyDrawer";
import LogDrawer from "./components/LogDrawer";
import { inboundExceptionPage, inboundExceptionDelete, inboundExceptionExport, inboundExceptionReplyUsers } from "@/apis/inHouse";
import { EXCEPTION_STATUS, EXCEPTION_TYPE } from "./data";
import moment from "moment";

export default {
  name: "inboundException",
  components: {
    InterForm,
    InterBtnBox,
    InterList,
    ExceptionFormDrawer,
    ReplyDrawer,
    LogDrawer,
  },
  data() {
    return {
      // 当前 Tab：product / parcel
      activeName: "product",
      // 查询与分页参数
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      // 列表数据
      dataSource: [],
      // 需回复人，来自后端 Nacos 配置
      replyUserOptions: [],
    };
  },
  created() {
    this.loadReplyUsers();
  },
  computed: {
    // 当前异常类型
    exceptionType: function () {
      return this.activeName === "parcel" ? EXCEPTION_TYPE.PARCEL : EXCEPTION_TYPE.PRODUCT;
    },
  },
  methods: {
    // 拉取需回复人，Nacos 加人后刷新页面即可
    loadReplyUsers: function () {
      inboundExceptionReplyUsers().then((res) => {
        if (res.code === 0) {
          this.replyUserOptions = res.data || [];
        }
      });
    },
    // 切换商品/包裹 Tab，清空筛选后查当前场景数据
    handleTabClick: function () {
      this.query.current = 1;
      if (this.$refs.InterForm) {
        this.$refs.InterForm.resetAndQuery();
      }
    },
    // 查询表单提交
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
        current: 1,
      };
      this.getDataSource();
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage();
      }
    },
    // 分页变化
    pageChangeCall: function (payload) {
      this.query.current = payload.current;
      this.query.pageSize = payload.pageSize;
      this.getDataSource();
    },
    // 拉取列表
    getDataSource: function () {
      const params = {
        ...this.query,
        pageNum: this.query.current,
        exceptionType: this.exceptionType,
      };
      inboundExceptionPage(params).then((res) => {
        if (res.code === 0) {
          this.dataSource = res.data.records || [];
          this.query.total = res.data.total || 0;
        }
      });
    },
    // 打开新增抽屉
    openCreate: function () {
      this.$refs.formDrawer.open("new", { exceptionType: this.exceptionType });
    },
    // 打开编辑抽屉
    openEdit: function (record) {
      this.$refs.formDrawer.open("edit", record);
    },
    // 打开回复抽屉
    openReply: function (record) {
      this.$refs.replyDrawer.open(record);
    },
    // 打开操作日志抽屉
    openLog: function (record) {
      this.$refs.logDrawer.open(record);
    },
    // 删除未回复记录，已回复不可删
    removeRecord: function (record) {
      if (Number(record.status) === EXCEPTION_STATUS.REPLIED) {
        this.$message.warning("已回复记录不可删除");
        return;
      }
      this.$confirm("确认删除该异常记录？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        inboundExceptionDelete({ exceptionCode: record.exceptionCode }).then((res) => {
          if (res.code === 0) {
            this.$message.success("删除成功");
            this.getDataSource();
          }
        });
      }).catch(() => {});
    },
    // 导出 Excel
    exportExcel: function () {
      const params = {
        ...this.query,
        pageNum: this.query.current,
      };
      inboundExceptionExport(params).then((res) => {
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        const fileName = "异常登记_" + moment().format("YYYY-MM-DD") + ".xls";
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(objectUrl);
      });
    },
  },
};
</script>

<style scoped>
.inbound-exception-page {
  padding: 0 10px;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
}
</style>
